import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import WithConsumer from '../context/WithConsumer';


export default class ModLink extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
	        	<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        	<div className="l-grid">
			        	<div className="l-grid__col">
			        		<div className="c-link-grid">
			        			<div className="c-link-grid__left">
				        			<div className="c-link-grid__text">
						        		{block.heading &&
							        		<h2 className="c-link-grid__text__heading">{ block.heading }</h2>
							        	}
							        	{block.text &&
								        	<div className="c-link-grid__text__text scope-text" dangerouslySetInnerHTML={ {__html: block.text } }></div>
							        	}
							        	{block.button_text && block.button_url && block.button_url.includes('https:') &&
								        	<a href={block.button_url} className="c-link-grid__text__button" target="_blank">{ block.button_text }</a>
								        }
								        {block.button_text && block.button_url && block.button_url.includes('http:') &&
								        	<a href={block.button_url} className="c-link-grid__text__button" target="_blank">{ block.button_text }</a>
								        }
								        {block.button_text && block.button_url && !block.button_url.includes('https') && !block.button_url.includes('http') &&
								        	<Link to={{ pathname: block.button_url }} className="c-link-grid__text__button">{ block.button_text }</Link>
								        }
						        	</div>
						        	<div className="c-link-grid__block c-link-grid__block--1">
					        			{block.block_heading_1 && 
					        				<Link to={{ pathname: block.block_url_1 }} className="c-link-grid__block__link">
					        					<div className="c-link-grid__block__image">
													<FadeIn duration={250}>
														{onload => (
															<img
																alt={ block.block_heading_1 } 
																src={ block.block_src_image_1 } 
																srcSet={ block.block_srcset_image_1 } 
																onLoad={ onload }
															/>
														)}
													</FadeIn>
												</div>
												<div className="c-link-grid__block__text">
													<h5 className="c-link-grid__block__heading">{ block.block_heading_1 }</h5>
													<p className="c-link-grid__block__more">See all</p>
												</div>
					        				</Link>
					        			}
						        	</div>
						        	<div className="c-link-grid__block c-link-grid__block--2">
					        			{block.block_heading_2 && 
					        				<Link to={{ pathname: block.block_url_2 }} className="c-link-grid__block__link">
					        					<div className="c-link-grid__block__image">
													<FadeIn duration={250}>
														{onload => (
															<img
																alt={block.block_heading_2} 
																src={block.block_src_image_2} 
																srcSet={block.block_srcset_image_2} 
																onLoad={onload}
															/>
														)}
													</FadeIn>
												</div>
												<div className="c-link-grid__block__text">
													<h5 className="c-link-grid__block__heading">{ block.block_heading_2 }</h5>
													<p className="c-link-grid__block__more">See all</p>
												</div>
					        				</Link>
					        			}
						        	</div>
						        </div>
						        <div className="c-link-grid__right">
						        	<div className="c-link-grid__block c-link-grid__block--3">
					        			{block.block_heading_3 && 
					        				<Link to={{ pathname: block.block_url_3 }} className="c-link-grid__block__link">
					        					<div className="c-link-grid__block__image">
													<FadeIn duration={250}>
														{onload => (
															<img
																alt={block.block_heading_3} 
																src={block.block_src_image_3} 
																srcSet={block.block_srcset_image_3} 
																onLoad={onload}
															/>
														)}
													</FadeIn>
												</div>
												<div className="c-link-grid__block__text">
													<h5 className="c-link-grid__block__heading">{ block.block_heading_3 }</h5>
													<p className="c-link-grid__block__more">See all</p>
												</div>
					        				</Link>
					        			}
						        	</div>
						        </div>
					        </div>
			        	</div>
			        </div>
				</ScrollAnimation>
			</div>
		)
	};

};
